export default __webpack_public_path__ + "static/media/ice-Bucket.da9c345c.svg";